import { render, staticRenderFns } from "./AboutUs_FR.vue?vue&type=template&id=b9a56d00&scoped=true&"
import script from "./AboutUs_FR.vue?vue&type=script&lang=js&"
export * from "./AboutUs_FR.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_FR.vue?vue&type=style&index=0&id=b9a56d00&prod&lang=css&"
import style1 from "./AboutUs_FR.vue?vue&type=style&index=1&id=b9a56d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a56d00",
  null
  
)

export default component.exports